
//const DocDocs = () => import('../../components/Policy/AllDocs')
const FileBrowser = () => import('../../library/FileBrowser')
const DocHTMLEditor = () => import('../../components/documents/HTMLEditor')
const Table = () => import('@/../../coreui/components/ServerTable')
export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('Documents'))  {
    routes = [
      //{
      //  path: '/DocDocs',
      //  name: 'DocDocs',
      //  component: DocDocs
      //},
      {
        path: '/DocFileUpload',
        name: 'DocFileUpload',
        component: FileBrowser,
        props: {
          isSuper: 'no',
          mode: 'browse'
        }
      },
      {
        path: '/DocHTMLEditor',
        name: 'DocHTMLEditor',
        component: DocHTMLEditor,
        props: {
          isSuper: 'no'
        }
      },
      {
        name: 'DocList', 
        path: '/DocList', 
        component: Table, 
        props: {
          schema: 'sch_cortex_user_documents', 
          table: 'org_app_documents',
          server: 'org'
        }
      },
      {
        name: 'TeamGroups',
        path: '/TeamGroups',
        component: Table,
        props: {
          schema: 'sch_set_groups',
          table: 'groups',
          server: 'orig'
        }
      },
    ]
  } 
  return routes
}
